module.exports = __webpack_public_path__ + "img/rafal.35f18ce.png";